import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Missing Supabase environment variables:', {
        url: !!supabaseUrl,
        key: !!supabaseAnonKey
    })
    throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        autoRefreshToken: true,
        persistSession: true
    },
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})

// Make supabase available globally for debugging
if (typeof window !== 'undefined') {
    window.supabase = supabase;
    
    // Add verification function
    window.verifyUserAccess = async () => {
        console.log('🔍 Verifying user access eligibility...\n');
        
        try {
            // Get session
            const { data: { session } } = await window.supabase.auth.getSession();
            if (!session?.user) {
                console.log('❌ No session found');
                return;
            }
            
            console.log('✅ Session exists for:', session.user.email);
            
            // Get profile
            const { data: profile, error } = await window.supabase
                .from('user_profiles')
                .select('*')
                .eq('id', session.user.id)
                .single();
            
            if (error) {
                console.error('❌ Profile error:', error);
                return;
            }
            
            console.log('✅ Profile found');
            
            // Check quiz completion
            const quizCompleted = profile.quiz_completed === true || profile.quiz_completed === 'true';
            console.log('🎯 Quiz completed:', quizCompleted, '(raw value:', profile.quiz_completed, ')');
            
            // Check subscription
            let subStatus = profile.subscription_status;
            if (profile.subscription_ends_at) {
                const endDate = new Date(profile.subscription_ends_at);
                if (endDate < new Date()) {
                    subStatus = 'expired';
                } else if (profile.subscription_status === 'cancelled') {
                    // Cancelled subscription is still active until end date
                    subStatus = 'active';
                }
            }
            console.log('💳 Subscription status:', subStatus);
            console.log('📅 Subscription ends:', profile.subscription_ends_at);
            
            // Final eligibility
            const isEligible = quizCompleted && subStatus === 'active';
            console.log('🎉 Should have access:', isEligible);
            
            if (!isEligible) {
                if (!quizCompleted) console.log('❌ Blocked by: Quiz not completed');
                if (subStatus !== 'active') console.log('❌ Blocked by: Inactive subscription');
            }
            
            // Check current URL
            console.log('🌍 Current URL:', window.location.href);
            
            return { isEligible, profile, session };
            
        } catch (err) {
            console.error('❌ Error:', err);
        }
    };
}
